window.DMC_COLORS = [
  { number: "blanc", name: "White", hex: "#FFFFFF", family: "white" },
  { number: "ecru", name: "Ecru", hex: "#F0E6D2", family: "neutral" },
  { number: "B5200", name: "Snow White", hex: "#FFFFFF", family: "white" },
  { number: "150", name: "Dusty Rose Ultra Very Dark", hex: "#AB596D", family: "pink" },
  { number: "151", name: "Dusty Rose Very Light", hex: "#F0C4CC", family: "pink" },
  { number: "152", name: "Shell Pink Medium Light", hex: "#E2A099", family: "pink" },
  { number: "153", name: "Violet Very Light", hex: "#E6CEE3", family: "purple" },
  { number: "154", name: "Grape Very Dark", hex: "#572433", family: "purple" },
  { number: "155", name: "Blue Violet Medium Dark", hex: "#9891BB", family: "purple" },
  { number: "156", name: "Blue Violet Medium Light", hex: "#A3A3CC", family: "purple" },
  { number: "157", name: "Cornflower Blue Very Light", hex: "#BBB7D3", family: "blue" },
  { number: "158", name: "Cornflower Blue Very Dark", hex: "#4C526E", family: "blue" },
  { number: "159", name: "Blue Grey Light", hex: "#C3C8D8", family: "blue" },
  { number: "160", name: "Blue Grey Medium", hex: "#999FB3", family: "blue" },
  { number: "161", name: "Blue Grey", hex: "#7680A0", family: "blue" },
  { number: "162", name: "Blue Ultra Very Light", hex: "#DBECF5", family: "blue" },
  { number: "163", name: "Celadon Green Medium", hex: "#4DA373", family: "green" },
  { number: "164", name: "Forest Green Light", hex: "#C8D8B0", family: "green" },
  { number: "165", name: "Moss Green Very Light", hex: "#EFF4A6", family: "green" },
  { number: "166", name: "Moss Green Medium Light", hex: "#C0C840", family: "green" },
  { number: "167", name: "Yellow Beige Very Dark", hex: "#A47B43", family: "brown" },
  { number: "168", name: "Pewter Very Light", hex: "#D1D1D1", family: "grey" },
  { number: "169", name: "Pewter Light", hex: "#B0B0B0", family: "grey" },
  { number: "208", name: "Lavender Very Dark", hex: "#835E9F", family: "purple" },
  { number: "209", name: "Lavender Dark", hex: "#A37DB8", family: "purple" },
  { number: "210", name: "Lavender Medium", hex: "#C4A2D3", family: "purple" },
  { number: "211", name: "Lavender Light", hex: "#DCC7E1", family: "purple" },
  { number: "221", name: "Shell Pink Very Dark", hex: "#883533", family: "red" },
  { number: "222", name: "Shell Pink Medium Dark", hex: "#A44D4D", family: "pink" },
  { number: "223", name: "Shell Pink Light", hex: "#CC8E84", family: "pink" },
  { number: "224", name: "Shell Pink Very Light", hex: "#EBBEAF", family: "pink" },
  { number: "225", name: "Shell Pink Ultra Very Light", hex: "#FFE0D0", family: "pink" },
  { number: "300", name: "Mahogany Very Dark", hex: "#6B2B10", family: "brown" },
  { number: "301", name: "Mahogany Medium", hex: "#B55223", family: "brown" },
  { number: "304", name: "Christmas Red Medium", hex: "#B72024", family: "red" },
  { number: "307", name: "Lemon", hex: "#FDED54", family: "yellow" },
  { number: "309", name: "Rose Dark", hex: "#BA3348", family: "red" },
  { number: "310", name: "Black", hex: "#2C2C2C", family: "black" },
  { number: "311", name: "Navy Blue Medium", hex: "#1C4770", family: "blue" },
  { number: "312", name: "Navy Blue Light", hex: "#345884", family: "blue" },
  { number: "315", name: "Antique Mauve Medium Dark", hex: "#814854", family: "pink" },
  { number: "316", name: "Antique Mauve Medium", hex: "#B77180", family: "pink" },
  { number: "317", name: "Pewter Grey", hex: "#6C6C6C", family: "grey" },
  { number: "318", name: "Steel Grey Light", hex: "#A3A3A3", family: "grey" },
  { number: "319", name: "Pistachio Green Very Dark", hex: "#205A30", family: "green" },
  { number: "320", name: "Pistachio Green Medium", hex: "#6B8E55", family: "green" },
  { number: "321", name: "Christmas Red", hex: "#C72B35", family: "red" },
  { number: "322", name: "Navy Blue Very Light", hex: "#5A8DB8", family: "blue" },
  { number: "326", name: "Rose Very Dark", hex: "#B3374A", family: "red" },
  { number: "327", name: "Violet Dark", hex: "#633472", family: "purple" },
  { number: "333", name: "Blue Violet Very Dark", hex: "#5C3475", family: "purple" },
  { number: "334", name: "Baby Blue Medium", hex: "#739CBF", family: "blue" },
  { number: "335", name: "Rose", hex: "#EE5674", family: "pink" },
  { number: "336", name: "Navy Blue", hex: "#253B73", family: "blue" },
  { number: "340", name: "Blue Violet Medium", hex: "#AD9BCB", family: "purple" },
  { number: "341", name: "Blue Violet Light", hex: "#B7B5D0", family: "purple" },
  { number: "347", name: "Salmon Very Dark", hex: "#BF2B2E", family: "red" },
  { number: "349", name: "Coral Dark", hex: "#D21035", family: "red" },
  { number: "350", name: "Coral Medium", hex: "#E04848", family: "red" },
  { number: "351", name: "Coral", hex: "#E96A67", family: "red" },
  { number: "352", name: "Coral Light", hex: "#FD9078", family: "orange" },
  { number: "353", name: "Peach", hex: "#FEB0A8", family: "pink" },
  { number: "355", name: "Terra Cotta Dark", hex: "#984B35", family: "brown" },
  { number: "356", name: "Terra Cotta Medium", hex: "#C5705C", family: "brown" },
  { number: "367", name: "Pistachio Green Dark", hex: "#5E7E43", family: "green" },
  { number: "368", name: "Pistachio Green Light", hex: "#A6C88E", family: "green" },
  { number: "369", name: "Pistachio Green Very Light", hex: "#D4E8B9", family: "green" },
  { number: "370", name: "Mustard Medium", hex: "#B89052", family: "brown" },
  { number: "371", name: "Mustard", hex: "#BF9B62", family: "brown" },
  { number: "372", name: "Mustard Light", hex: "#CCA95B", family: "brown" },
  { number: "400", name: "Mahogany Dark", hex: "#8F3415", family: "brown" },
  { number: "402", name: "Mahogany Very Light", hex: "#F7A777", family: "orange" },
  { number: "407", name: "Desert Sand Medium", hex: "#BC8673", family: "brown" },
  { number: "413", name: "Pewter Grey Dark", hex: "#4D4D4D", family: "grey" },
  { number: "414", name: "Steel Grey Dark", hex: "#8C8C8C", family: "grey" },
  { number: "415", name: "Pearl Grey", hex: "#C5C5C5", family: "grey" },
  { number: "420", name: "Hazelnut Brown Dark", hex: "#A0753A", family: "brown" },
  { number: "422", name: "Hazelnut Brown Light", hex: "#C6A86B", family: "brown" },
  { number: "433", name: "Brown Medium", hex: "#7A4526", family: "brown" },
  { number: "434", name: "Brown Light", hex: "#985E32", family: "brown" },
  { number: "435", name: "Brown Very Light", hex: "#BA7B3E", family: "brown" },
  { number: "436", name: "Tan", hex: "#CB9757", family: "brown" },
  { number: "437", name: "Tan Light", hex: "#D4A76A", family: "brown" },
  { number: "444", name: "Lemon Dark", hex: "#FFD700", family: "yellow" },
  { number: "445", name: "Lemon Light", hex: "#FFFAB0", family: "yellow" },
  { number: "451", name: "Shell Grey Dark", hex: "#8B827D", family: "grey" },
  { number: "452", name: "Shell Grey Medium", hex: "#B5A9A3", family: "grey" },
  { number: "453", name: "Shell Grey Light", hex: "#CBC1BD", family: "grey" },
  { number: "469", name: "Avocado Green", hex: "#729A3B", family: "green" },
  { number: "470", name: "Avocado Green Light", hex: "#94B555", family: "green" },
  { number: "471", name: "Avocado Green Very Light", hex: "#AEC45E", family: "green" },
  { number: "472", name: "Avocado Green Ultra Light", hex: "#D8E67C", family: "green" },
  { number: "498", name: "Christmas Red Dark", hex: "#A7132A", family: "red" },
  { number: "500", name: "Blue Green Very Dark", hex: "#04594D", family: "green" },
  { number: "501", name: "Blue Green Dark", hex: "#3B7365", family: "green" },
  { number: "502", name: "Blue Green", hex: "#5B9882", family: "green" },
  { number: "503", name: "Blue Green Medium", hex: "#7CB69A", family: "green" },
  { number: "504", name: "Blue Green Very Light", hex: "#C4DBC8", family: "green" },
  { number: "505", name: "Jade Green", hex: "#33816B", family: "green" },
  { number: "517", name: "Wedgwood Dark", hex: "#3B7199", family: "blue" },
  { number: "518", name: "Wedgwood Light", hex: "#4F91AF", family: "blue" },
  { number: "519", name: "Sky Blue", hex: "#7EB5D6", family: "blue" },
  { number: "520", name: "Fern Green Dark", hex: "#666B52", family: "green" },
  { number: "522", name: "Fern Green", hex: "#8F9A7B", family: "green" },
  { number: "523", name: "Fern Green Light", hex: "#9BAA87", family: "green" },
  { number: "524", name: "Fern Green Very Light", hex: "#BBBFA3", family: "green" },
  { number: "535", name: "Ash Grey Very Light", hex: "#636363", family: "grey" },
  { number: "543", name: "Beige Brown Ultra Very Light", hex: "#F2DFC9", family: "neutral" },
  { number: "550", name: "Violet Very Dark", hex: "#5C2463", family: "purple" },
  { number: "552", name: "Violet Medium", hex: "#803B82", family: "purple" },
  { number: "553", name: "Violet", hex: "#A063A0", family: "purple" },
  { number: "554", name: "Violet Light", hex: "#C392C2", family: "purple" },
  { number: "561", name: "Jade Very Dark", hex: "#2C6E4F", family: "green" },
  { number: "562", name: "Jade Medium", hex: "#53916B", family: "green" },
  { number: "563", name: "Jade Light", hex: "#8FC0A3", family: "green" },
  { number: "564", name: "Jade Very Light", hex: "#A7D5B8", family: "green" },
  { number: "580", name: "Moss Green Dark", hex: "#888E37", family: "green" },
  { number: "581", name: "Moss Green", hex: "#A7AE3E", family: "green" },
  { number: "597", name: "Turquoise", hex: "#5BB0A5", family: "blue" },
  { number: "598", name: "Turquoise Light", hex: "#90D4CC", family: "blue" },
  { number: "600", name: "Cranberry Very Dark", hex: "#CD2F55", family: "pink" },
  { number: "601", name: "Cranberry Dark", hex: "#D13663", family: "pink" },
  { number: "602", name: "Cranberry Medium", hex: "#E24874", family: "pink" },
  { number: "603", name: "Cranberry", hex: "#FF7396", family: "pink" },
  { number: "604", name: "Cranberry Light", hex: "#FF8FAB", family: "pink" },
  { number: "605", name: "Cranberry Very Light", hex: "#FFACBE", family: "pink" },
  { number: "606", name: "Bright Orange Red", hex: "#FA2B12", family: "red" },
  { number: "608", name: "Bright Orange", hex: "#FD5B1F", family: "orange" },
  { number: "610", name: "Drab Brown Very Dark", hex: "#796340", family: "brown" },
  { number: "611", name: "Drab Brown Dark", hex: "#887150", family: "brown" },
  { number: "612", name: "Drab Brown Medium", hex: "#BC9F78", family: "brown" },
  { number: "613", name: "Drab Brown Light", hex: "#CCAF8B", family: "brown" },
  { number: "632", name: "Desert Sand Ultra Very Dark", hex: "#8D5E47", family: "brown" },
  { number: "640", name: "Beige Grey Very Dark", hex: "#8C8272", family: "grey" },
  { number: "642", name: "Beige Grey Dark", hex: "#A89E8E", family: "grey" },
  { number: "644", name: "Beige Grey Medium", hex: "#C1BAA9", family: "neutral" },
  { number: "645", name: "Beaver Grey Very Dark", hex: "#7A766E", family: "grey" },
  { number: "646", name: "Beaver Grey Dark", hex: "#8E8A80", family: "grey" },
  { number: "647", name: "Beaver Grey Medium", hex: "#ACA89E", family: "grey" },
  { number: "648", name: "Beaver Grey Light", hex: "#BCB8AE", family: "grey" },
  { number: "666", name: "Christmas Red Bright", hex: "#E31D42", family: "red" },
  { number: "676", name: "Old Gold Light", hex: "#E6C672", family: "yellow" },
  { number: "677", name: "Old Gold Very Light", hex: "#F5E6B5", family: "yellow" },
  { number: "680", name: "Old Gold Dark", hex: "#BC8A34", family: "yellow" },
  { number: "699", name: "Christmas Green", hex: "#056A0E", family: "green" },
  { number: "700", name: "Christmas Green Bright", hex: "#077416", family: "green" },
  { number: "701", name: "Christmas Green Light", hex: "#238E23", family: "green" },
  { number: "702", name: "Kelly Green", hex: "#47A22E", family: "green" },
  { number: "703", name: "Chartreuse", hex: "#7BB536", family: "green" },
  { number: "704", name: "Chartreuse Bright", hex: "#9ECA3C", family: "green" },
  { number: "712", name: "Cream", hex: "#FFF8E1", family: "neutral" },
  { number: "718", name: "Plum", hex: "#9C2462", family: "pink" },
  { number: "720", name: "Orange Spice Dark", hex: "#E55B20", family: "orange" },
  { number: "721", name: "Orange Spice Medium", hex: "#F27842", family: "orange" },
  { number: "722", name: "Orange Spice Light", hex: "#F7A66C", family: "orange" },
  { number: "725", name: "Topaz", hex: "#FFC840", family: "yellow" },
  { number: "726", name: "Topaz Light", hex: "#FCD667", family: "yellow" },
  { number: "727", name: "Topaz Very Light", hex: "#FFF1A0", family: "yellow" },
  { number: "728", name: "Topaz Dark", hex: "#E8AD24", family: "yellow" },
  { number: "729", name: "Old Gold Medium", hex: "#D0A23D", family: "yellow" },
  { number: "730", name: "Olive Green Very Dark", hex: "#827A2E", family: "green" },
  { number: "731", name: "Olive Green Dark", hex: "#8B8334", family: "green" },
  { number: "732", name: "Olive Green", hex: "#948C38", family: "green" },
  { number: "733", name: "Olive Green Medium", hex: "#ACA24B", family: "green" },
  { number: "734", name: "Olive Green Light", hex: "#C0B55E", family: "green" },
  { number: "738", name: "Tan Very Light", hex: "#ECCC9D", family: "neutral" },
  { number: "739", name: "Tan Ultra Very Light", hex: "#F5DEB3", family: "neutral" },
  { number: "740", name: "Tangerine", hex: "#FF8C00", family: "orange" },
  { number: "741", name: "Tangerine Medium", hex: "#FFA329", family: "orange" },
  { number: "742", name: "Tangerine Light", hex: "#FFBF47", family: "orange" },
  { number: "743", name: "Yellow Medium", hex: "#FED340", family: "yellow" },
  { number: "744", name: "Yellow Pale", hex: "#FFE175", family: "yellow" },
  { number: "745", name: "Yellow Pale Light", hex: "#FFE9A5", family: "yellow" },
  { number: "746", name: "Off White", hex: "#FFF8CC", family: "white" },
  { number: "747", name: "Sky Blue Very Light", hex: "#D5EFF6", family: "blue" },
  { number: "754", name: "Peach Light", hex: "#F7C4A4", family: "pink" },
  { number: "758", name: "Terra Cotta Very Light", hex: "#EEA988", family: "orange" },
  { number: "760", name: "Salmon", hex: "#F5A4A4", family: "pink" },
  { number: "761", name: "Salmon Light", hex: "#FFC0C0", family: "pink" },
  { number: "762", name: "Pearl Grey Very Light", hex: "#D8D8D8", family: "grey" },
  { number: "772", name: "Yellow Green Very Light", hex: "#E2EDC1", family: "green" },
  { number: "775", name: "Baby Blue Very Light", hex: "#D1E0F0", family: "blue" },
  { number: "776", name: "Pink Medium", hex: "#FCA4B4", family: "pink" },
  { number: "778", name: "Antique Mauve Very Light", hex: "#DFB5AF", family: "pink" },
  { number: "779", name: "Cocoa Dark", hex: "#6B4028", family: "brown" },
  { number: "780", name: "Topaz Ultra Very Dark", hex: "#946826", family: "brown" },
  { number: "781", name: "Topaz Very Dark", hex: "#A27528", family: "brown" },
  { number: "782", name: "Topaz Dark", hex: "#AE7D2B", family: "brown" },
  { number: "783", name: "Topaz Medium", hex: "#CE9B36", family: "yellow" },
  { number: "791", name: "Cornflower Blue Very Dark", hex: "#464C80", family: "blue" },
  { number: "792", name: "Cornflower Blue Dark", hex: "#5A6699", family: "blue" },
  { number: "793", name: "Cornflower Blue Medium", hex: "#7084B4", family: "blue" },
  { number: "794", name: "Cornflower Blue Light", hex: "#8FA4CE", family: "blue" },
  { number: "796", name: "Royal Blue Dark", hex: "#113E85", family: "blue" },
  { number: "797", name: "Royal Blue", hex: "#134B9B", family: "blue" },
  { number: "798", name: "Delft Blue Dark", hex: "#466DB3", family: "blue" },
  { number: "799", name: "Delft Blue Medium", hex: "#6688C8", family: "blue" },
  { number: "800", name: "Delft Blue Pale", hex: "#C0D4ED", family: "blue" },
  { number: "801", name: "Coffee Brown Dark", hex: "#5B3514", family: "brown" },
  { number: "803", name: "Baby Blue Ultra Very Dark", hex: "#2C5088", family: "blue" },
  { number: "806", name: "Peacock Blue Dark", hex: "#307B85", family: "blue" },
  { number: "807", name: "Peacock Blue", hex: "#64A4A4", family: "blue" },
  { number: "809", name: "Delft Blue", hex: "#94B3D9", family: "blue" },
  { number: "813", name: "Blue Light", hex: "#A1C5E2", family: "blue" },
  { number: "814", name: "Garnet Dark", hex: "#7B0031", family: "red" },
  { number: "815", name: "Garnet Medium", hex: "#871624", family: "red" },
  { number: "816", name: "Garnet", hex: "#971B2F", family: "red" },
  { number: "817", name: "Coral Red Very Dark", hex: "#E11300", family: "red" },
  { number: "818", name: "Baby Pink", hex: "#FFD3DC", family: "pink" },
  { number: "819", name: "Baby Pink Light", hex: "#FFE0E6", family: "pink" },
  { number: "820", name: "Royal Blue Very Dark", hex: "#0E365A", family: "blue" },
  { number: "822", name: "Beige Grey Light", hex: "#E0D7C6", family: "neutral" },
  { number: "823", name: "Navy Blue Dark", hex: "#17295A", family: "blue" },
  { number: "824", name: "Blue Very Dark", hex: "#396FAA", family: "blue" },
  { number: "825", name: "Blue Dark", hex: "#4678B4", family: "blue" },
  { number: "826", name: "Blue Medium", hex: "#6B98C8", family: "blue" },
  { number: "827", name: "Blue Very Light", hex: "#BDDDEE", family: "blue" },
  { number: "828", name: "Blue Ultra Very Light", hex: "#C5E1F0", family: "blue" },
  { number: "829", name: "Golden Olive Very Dark", hex: "#7E6B2B", family: "brown" },
  { number: "830", name: "Golden Olive Dark", hex: "#8C7630", family: "brown" },
  { number: "831", name: "Golden Olive Medium", hex: "#9C8536", family: "brown" },
  { number: "832", name: "Golden Olive", hex: "#B49338", family: "brown" },
  { number: "833", name: "Golden Olive Light", hex: "#C3A34B", family: "brown" },
  { number: "834", name: "Golden Olive Very Light", hex: "#D4B75B", family: "yellow" },
  { number: "838", name: "Beige Brown Very Dark", hex: "#5C3918", family: "brown" },
  { number: "839", name: "Beige Brown Dark", hex: "#6F4B25", family: "brown" },
  { number: "840", name: "Beige Brown Medium", hex: "#9A7F5F", family: "brown" },
  { number: "841", name: "Beige Brown Light", hex: "#AF9C7E", family: "brown" },
  { number: "842", name: "Beige Brown Very Light", hex: "#CCBEA0", family: "neutral" },
  { number: "844", name: "Beaver Grey Ultra Dark", hex: "#636058", family: "grey" },
  { number: "869", name: "Hazelnut Brown Very Dark", hex: "#836327", family: "brown" },
  { number: "890", name: "Pistachio Green Ultra Dark", hex: "#174726", family: "green" },
  { number: "891", name: "Carnation Dark", hex: "#FF4773", family: "pink" },
  { number: "892", name: "Carnation Medium", hex: "#FF6B8D", family: "pink" },
  { number: "893", name: "Carnation Light", hex: "#FC90A4", family: "pink" },
  { number: "894", name: "Carnation Very Light", hex: "#FFB0C1", family: "pink" },
  { number: "895", name: "Hunter Green Very Dark", hex: "#1B5B20", family: "green" },
  { number: "898", name: "Coffee Brown Very Dark", hex: "#492815", family: "brown" },
  { number: "899", name: "Rose Medium", hex: "#F06580", family: "pink" },
  { number: "900", name: "Burnt Orange Dark", hex: "#D35615", family: "orange" },
  { number: "902", name: "Garnet Very Dark", hex: "#6D0F24", family: "red" },
  { number: "904", name: "Parrot Green Very Dark", hex: "#557A1C", family: "green" },
  { number: "905", name: "Parrot Green Dark", hex: "#628B22", family: "green" },
  { number: "906", name: "Parrot Green Medium", hex: "#7FAC2A", family: "green" },
  { number: "907", name: "Parrot Green Light", hex: "#A8C44A", family: "green" },
  { number: "909", name: "Emerald Green Very Dark", hex: "#17653A", family: "green" },
  { number: "910", name: "Emerald Green Dark", hex: "#187E40", family: "green" },
  { number: "911", name: "Emerald Green Medium", hex: "#189048", family: "green" },
  { number: "912", name: "Emerald Green Light", hex: "#1BA258", family: "green" },
  { number: "913", name: "Nile Green Medium", hex: "#6DC490", family: "green" },
  { number: "915", name: "Plum Dark", hex: "#820043", family: "pink" },
  { number: "917", name: "Plum Medium", hex: "#9B004F", family: "pink" },
  { number: "918", name: "Red Copper Dark", hex: "#823C20", family: "brown" },
  { number: "919", name: "Red Copper", hex: "#A64818", family: "orange" },
  { number: "920", name: "Copper Medium", hex: "#AC5628", family: "orange" },
  { number: "921", name: "Copper", hex: "#C06328", family: "orange" },
  { number: "922", name: "Copper Light", hex: "#E27834", family: "orange" },
  { number: "924", name: "Grey Green Very Dark", hex: "#3A605C", family: "green" },
  { number: "926", name: "Grey Green Medium", hex: "#6E9C94", family: "green" },
  { number: "927", name: "Grey Green Light", hex: "#BDCFC8", family: "green" },
  { number: "928", name: "Grey Green Very Light", hex: "#DDE7E0", family: "green" },
  { number: "930", name: "Antique Blue Dark", hex: "#455E72", family: "blue" },
  { number: "931", name: "Antique Blue Medium", hex: "#5E7F95", family: "blue" },
  { number: "932", name: "Antique Blue Light", hex: "#8AAABB", family: "blue" },
  { number: "934", name: "Black Avocado Green", hex: "#313C22", family: "green" },
  { number: "935", name: "Avocado Green Dark", hex: "#424F2E", family: "green" },
  { number: "936", name: "Avocado Green Very Dark", hex: "#4C5C2E", family: "green" },
  { number: "937", name: "Avocado Green Medium", hex: "#5C7A34", family: "green" },
  { number: "938", name: "Coffee Brown Ultra Dark", hex: "#361D0B", family: "brown" },
  { number: "939", name: "Navy Blue Very Dark", hex: "#0E1E54", family: "blue" },
  { number: "940", name: "Cornflower Blue", hex: "#0064B5", family: "blue" },
  { number: "941", name: "Cornflower Blue Medium Deep", hex: "#447DBF", family: "blue" },
  { number: "943", name: "Aquamarine Medium", hex: "#1BA47E", family: "green" },
  { number: "945", name: "Tawny", hex: "#EFC0A0", family: "neutral" },
  { number: "946", name: "Burnt Orange Medium", hex: "#EB6307", family: "orange" },
  { number: "947", name: "Burnt Orange", hex: "#FF7B31", family: "orange" },
  { number: "948", name: "Peach Very Light", hex: "#FEE0CD", family: "pink" },
  { number: "950", name: "Desert Sand Light", hex: "#EEC7A9", family: "neutral" },
  { number: "951", name: "Tawny Light", hex: "#FFE0B5", family: "neutral" },
  { number: "954", name: "Nile Green", hex: "#88C9A2", family: "green" },
  { number: "955", name: "Nile Green Light", hex: "#A2D9B9", family: "green" },
  { number: "956", name: "Geranium", hex: "#FF6373", family: "pink" },
  { number: "957", name: "Geranium Pale", hex: "#FD9FA2", family: "pink" },
  { number: "958", name: "Sea Green Dark", hex: "#3EB1A0", family: "green" },
  { number: "959", name: "Sea Green Medium", hex: "#59C3B2", family: "green" },
  { number: "961", name: "Dusty Rose Dark", hex: "#CF6676", family: "pink" },
  { number: "962", name: "Dusty Rose Medium", hex: "#E6899C", family: "pink" },
  { number: "963", name: "Dusty Rose Ultra Very Light", hex: "#FFD3D6", family: "pink" },
  { number: "964", name: "Sea Green Light", hex: "#A3D9CF", family: "green" },
  { number: "966", name: "Baby Green Medium", hex: "#84C0AA", family: "green" },
  { number: "970", name: "Pumpkin Light", hex: "#F78B13", family: "orange" },
  { number: "971", name: "Pumpkin", hex: "#F76B06", family: "orange" },
  { number: "972", name: "Canary Deep", hex: "#FFB515", family: "yellow" },
  { number: "973", name: "Canary Bright", hex: "#FFE302", family: "yellow" },
  { number: "975", name: "Golden Brown Dark", hex: "#815218", family: "brown" },
  { number: "976", name: "Golden Brown Medium", hex: "#C28134", family: "brown" },
  { number: "977", name: "Golden Brown Light", hex: "#DC9B4E", family: "brown" },
  { number: "986", name: "Forest Green Very Dark", hex: "#3C6E38", family: "green" },
  { number: "987", name: "Forest Green Dark", hex: "#588B48", family: "green" },
  { number: "988", name: "Forest Green Medium", hex: "#73A55B", family: "green" },
  { number: "989", name: "Forest Green", hex: "#8EBC6E", family: "green" },
  { number: "991", name: "Aquamarine Dark", hex: "#478B6C", family: "green" },
  { number: "992", name: "Aquamarine Light", hex: "#6FC4A7", family: "green" },
  { number: "993", name: "Aquamarine Very Light", hex: "#90D5BA", family: "green" },
  { number: "995", name: "Electric Blue Dark", hex: "#2694DB", family: "blue" },
  { number: "996", name: "Electric Blue Medium", hex: "#30ACEC", family: "blue" },
  { number: "3011", name: "Khaki Green Dark", hex: "#89825E", family: "green" },
  { number: "3012", name: "Khaki Green Medium", hex: "#A49868", family: "green" },
  { number: "3013", name: "Khaki Green Light", hex: "#B9AE7E", family: "green" },
  { number: "3021", name: "Brown Grey Very Dark", hex: "#4F443A", family: "brown" },
  { number: "3022", name: "Brown Grey Medium", hex: "#8E8677", family: "grey" },
  { number: "3023", name: "Brown Grey Light", hex: "#AFA592", family: "grey" },
  { number: "3024", name: "Brown Grey Very Light", hex: "#C8C1B4", family: "grey" },
  { number: "3031", name: "Mocha Brown Very Dark", hex: "#4B3620", family: "brown" },
  { number: "3032", name: "Mocha Brown Medium", hex: "#B09F7E", family: "brown" },
  { number: "3033", name: "Mocha Brown Very Light", hex: "#D1C2A8", family: "neutral" },
  { number: "3041", name: "Antique Violet Medium", hex: "#917688", family: "purple" },
  { number: "3042", name: "Antique Violet Light", hex: "#B79EAC", family: "purple" },
  { number: "3045", name: "Yellow Beige Dark", hex: "#BC9244", family: "brown" },
  { number: "3046", name: "Yellow Beige Medium", hex: "#D5B267", family: "yellow" },
  { number: "3047", name: "Yellow Beige Light", hex: "#E8D294", family: "yellow" },
  { number: "3051", name: "Green Grey Dark", hex: "#5F694A", family: "green" },
  { number: "3052", name: "Green Grey Medium", hex: "#899368", family: "green" },
  { number: "3053", name: "Green Grey", hex: "#9CA579", family: "green" },
  { number: "3064", name: "Desert Sand", hex: "#C59374", family: "brown" },
  { number: "3072", name: "Beaver Grey Very Light", hex: "#E3E1DA", family: "grey" },
  { number: "3078", name: "Golden Yellow Very Light", hex: "#FFF3B3", family: "yellow" },
  { number: "3325", name: "Baby Blue Light", hex: "#B0CCEC", family: "blue" },
  { number: "3326", name: "Rose Light", hex: "#FBB0B6", family: "pink" },
  { number: "3328", name: "Salmon Dark", hex: "#E36D6D", family: "red" },
  { number: "3340", name: "Apricot Medium", hex: "#FF886E", family: "orange" },
  { number: "3341", name: "Apricot", hex: "#FCAB8D", family: "orange" },
  { number: "3345", name: "Hunter Green Dark", hex: "#1B6120", family: "green" },
  { number: "3346", name: "Hunter Green", hex: "#406C26", family: "green" },
  { number: "3347", name: "Yellow Green Medium", hex: "#71892E", family: "green" },
  { number: "3348", name: "Yellow Green Light", hex: "#CCE08E", family: "green" },
  { number: "3350", name: "Dusty Rose Ultra Dark", hex: "#BC4365", family: "pink" },
  { number: "3354", name: "Dusty Rose Light", hex: "#E4A0A0", family: "pink" },
  { number: "3362", name: "Pine Green Dark", hex: "#546435", family: "green" },
  { number: "3363", name: "Pine Green Medium", hex: "#6F7E48", family: "green" },
  { number: "3364", name: "Pine Green", hex: "#83965B", family: "green" },
  { number: "3371", name: "Black Brown", hex: "#2E1B0E", family: "brown" },
  { number: "3607", name: "Plum Light", hex: "#C54688", family: "pink" },
  { number: "3608", name: "Plum Very Light", hex: "#EA80AF", family: "pink" },
  { number: "3609", name: "Plum Ultra Light", hex: "#F4A5C9", family: "pink" },
  { number: "3685", name: "Mauve Very Dark", hex: "#882643", family: "pink" },
  { number: "3687", name: "Mauve", hex: "#C76278", family: "pink" },
  { number: "3688", name: "Mauve Medium", hex: "#E89DA3", family: "pink" },
  { number: "3689", name: "Mauve Light", hex: "#FBB3B9", family: "pink" },
  { number: "3705", name: "Melon Dark", hex: "#FF7F8C", family: "pink" },
  { number: "3706", name: "Melon Medium", hex: "#FFB0B5", family: "pink" },
  { number: "3708", name: "Melon Light", hex: "#FFCBD1", family: "pink" },
  { number: "3712", name: "Salmon Medium", hex: "#F18C88", family: "pink" },
  { number: "3713", name: "Salmon Very Light", hex: "#FFE0DD", family: "pink" },
  { number: "3716", name: "Dusty Rose Medium Very Light", hex: "#FFBDC5", family: "pink" },
  { number: "3721", name: "Shell Pink Dark", hex: "#A14C50", family: "red" },
  { number: "3722", name: "Shell Pink Medium", hex: "#BC6C5F", family: "pink" },
  { number: "3726", name: "Antique Mauve Dark", hex: "#985966", family: "pink" },
  { number: "3727", name: "Antique Mauve Light", hex: "#DBA5AE", family: "pink" },
  { number: "3731", name: "Dusty Rose Very Dark", hex: "#C45E72", family: "pink" },
  { number: "3733", name: "Dusty Rose", hex: "#E88092", family: "pink" },
  { number: "3740", name: "Antique Violet Dark", hex: "#785966", family: "purple" },
  { number: "3743", name: "Antique Violet Very Light", hex: "#D7C4D0", family: "purple" },
  { number: "3746", name: "Blue Violet Dark", hex: "#776CA0", family: "purple" },
  { number: "3747", name: "Blue Violet Very Light", hex: "#D0D0EA", family: "purple" },
  { number: "3750", name: "Antique Blue Very Dark", hex: "#385E72", family: "blue" },
  { number: "3752", name: "Antique Blue Very Light", hex: "#C7D4E0", family: "blue" },
  { number: "3753", name: "Antique Blue Ultra Very Light", hex: "#DBDEE8", family: "blue" },
  { number: "3755", name: "Baby Blue", hex: "#93B4D7", family: "blue" },
  { number: "3756", name: "Baby Blue Ultra Very Light", hex: "#EEFBFF", family: "blue" },
  { number: "3760", name: "Wedgwood Medium", hex: "#3E8AA0", family: "blue" },
  { number: "3761", name: "Sky Blue Light", hex: "#AAD5E5", family: "blue" },
  { number: "3765", name: "Peacock Blue Very Dark", hex: "#1E6E70", family: "blue" },
  { number: "3766", name: "Peacock Blue Light", hex: "#6EC5C0", family: "blue" },
  { number: "3768", name: "Grey Green Dark", hex: "#657E78", family: "green" },
  { number: "3770", name: "Tawny Very Light", hex: "#FFF0D8", family: "neutral" },
  { number: "3771", name: "Terra Cotta Ultra Very Light", hex: "#F4B28B", family: "orange" },
  { number: "3772", name: "Desert Sand Very Dark", hex: "#A0704E", family: "brown" },
  { number: "3773", name: "Desert Sand Medium", hex: "#D09878", family: "brown" },
  { number: "3774", name: "Desert Sand Very Light", hex: "#F5D5C0", family: "neutral" },
  { number: "3776", name: "Mahogany Light", hex: "#CF7838", family: "orange" },
  { number: "3777", name: "Terra Cotta Very Dark", hex: "#863424", family: "brown" },
  { number: "3778", name: "Terra Cotta Light", hex: "#D88B76", family: "orange" },
  { number: "3779", name: "Terra Cotta Ultra Very Light Rosewood", hex: "#F7C4A8", family: "pink" },
  { number: "3781", name: "Mocha Brown Dark", hex: "#6B513C", family: "brown" },
  { number: "3782", name: "Mocha Brown Light", hex: "#C5AE8E", family: "brown" },
  { number: "3787", name: "Brown Grey Dark", hex: "#6B6050", family: "brown" },
  { number: "3790", name: "Beige Grey Ultra Dark", hex: "#6B5F4F", family: "brown" },
  { number: "3799", name: "Pewter Grey Very Dark", hex: "#424242", family: "grey" },
  { number: "3801", name: "Christmas Red Very Dark", hex: "#E42041", family: "red" },
  { number: "3802", name: "Antique Mauve Very Dark", hex: "#71323E", family: "red" },
  { number: "3803", name: "Mauve Dark", hex: "#8E2449", family: "pink" },
  { number: "3804", name: "Cyclamen Pink Dark", hex: "#D02A6C", family: "pink" },
  { number: "3805", name: "Cyclamen Pink", hex: "#F0417E", family: "pink" },
  { number: "3806", name: "Cyclamen Pink Light", hex: "#FF80A8", family: "pink" },
  { number: "3807", name: "Cornflower Blue", hex: "#6070A8", family: "blue" },
  { number: "3808", name: "Turquoise Ultra Very Dark", hex: "#1B5E5E", family: "blue" },
  { number: "3809", name: "Turquoise Very Dark", hex: "#367878", family: "blue" },
  { number: "3810", name: "Turquoise Dark", hex: "#488D8C", family: "blue" },
  { number: "3811", name: "Turquoise Very Light", hex: "#BBE4E4", family: "blue" },
  { number: "3812", name: "Sea Green Very Dark", hex: "#2E8E76", family: "green" },
  { number: "3813", name: "Blue Green Light", hex: "#B0D4BD", family: "green" },
  { number: "3814", name: "Aquamarine", hex: "#508B6D", family: "green" },
  { number: "3815", name: "Celadon Green Dark", hex: "#477E5D", family: "green" },
  { number: "3816", name: "Celadon Green", hex: "#6BA480", family: "green" },
  { number: "3817", name: "Celadon Green Light", hex: "#99C4A5", family: "green" },
  { number: "3818", name: "Emerald Green Ultra Very Dark", hex: "#115C2B", family: "green" },
  { number: "3819", name: "Moss Green Light", hex: "#E0E455", family: "green" },
  { number: "3820", name: "Straw Dark", hex: "#DFB438", family: "yellow" },
  { number: "3821", name: "Straw", hex: "#F0C84C", family: "yellow" },
  { number: "3822", name: "Straw Light", hex: "#F6D974", family: "yellow" },
  { number: "3823", name: "Yellow Ultra Pale", hex: "#FFF8CC", family: "yellow" },
  { number: "3824", name: "Apricot Light", hex: "#FEACA5", family: "pink" },
  { number: "3825", name: "Pumpkin Pale", hex: "#FDBE87", family: "orange" },
  { number: "3826", name: "Golden Brown", hex: "#AD7133", family: "brown" },
  { number: "3827", name: "Golden Brown Pale", hex: "#F7C568", family: "yellow" },
  { number: "3828", name: "Hazelnut Brown", hex: "#A98654", family: "brown" },
  { number: "3829", name: "Old Gold Very Dark", hex: "#A87C1F", family: "brown" },
  { number: "3830", name: "Terra Cotta", hex: "#B85C4A", family: "red" },
  { number: "3831", name: "Raspberry Dark", hex: "#B43252", family: "red" },
  { number: "3832", name: "Raspberry Medium", hex: "#DB566B", family: "pink" },
  { number: "3833", name: "Raspberry Light", hex: "#EA8891", family: "pink" },
  { number: "3834", name: "Grape Dark", hex: "#724272", family: "purple" },
  { number: "3835", name: "Grape Medium", hex: "#9467A0", family: "purple" },
  { number: "3836", name: "Grape Light", hex: "#BA92B7", family: "purple" },
  { number: "3837", name: "Lavender Ultra Dark", hex: "#6C3480", family: "purple" },
  { number: "3838", name: "Lavender Blue Dark", hex: "#5C6BAA", family: "blue" },
  { number: "3839", name: "Lavender Blue Medium", hex: "#7B8CC0", family: "blue" },
  { number: "3840", name: "Lavender Blue Light", hex: "#B0BAD9", family: "blue" },
  { number: "3841", name: "Baby Blue Pale", hex: "#CDDEF2", family: "blue" },
  { number: "3842", name: "Wedgwood Very Dark", hex: "#26607C", family: "blue" },
  { number: "3843", name: "Electric Blue", hex: "#14A5D8", family: "blue" },
  { number: "3844", name: "Bright Turquoise Dark", hex: "#12ADC2", family: "blue" },
  { number: "3845", name: "Bright Turquoise Medium", hex: "#24C8DA", family: "blue" },
  { number: "3846", name: "Bright Turquoise Light", hex: "#68DFE5", family: "blue" },
  { number: "3847", name: "Teal Green Dark", hex: "#307774", family: "green" },
  { number: "3848", name: "Teal Green Medium", hex: "#559E96", family: "green" },
  { number: "3849", name: "Teal Green Light", hex: "#52B5A4", family: "green" },
  { number: "3850", name: "Bright Green Dark", hex: "#378C72", family: "green" },
  { number: "3851", name: "Bright Green Light", hex: "#49B48C", family: "green" },
  { number: "3852", name: "Straw Very Dark", hex: "#CD9700", family: "yellow" },
  { number: "3853", name: "Autumn Gold Dark", hex: "#F2963A", family: "orange" },
  { number: "3854", name: "Autumn Gold Medium", hex: "#F2B262", family: "orange" },
  { number: "3855", name: "Autumn Gold Light", hex: "#FAD68C", family: "yellow" },
  { number: "3856", name: "Mahogany Ultra Very Light", hex: "#FFD0A4", family: "orange" },
  { number: "3857", name: "Rosewood Dark", hex: "#6C302E", family: "brown" },
  { number: "3858", name: "Rosewood Medium", hex: "#964645", family: "red" },
  { number: "3859", name: "Rosewood Light", hex: "#BA8978", family: "brown" },
  { number: "3860", name: "Cocoa", hex: "#7C4C3C", family: "brown" },
  { number: "3861", name: "Cocoa Light", hex: "#A67C6C", family: "brown" },
  { number: "3862", name: "Mocha Beige Dark", hex: "#8A6E4E", family: "brown" },
  { number: "3863", name: "Mocha Beige Medium", hex: "#A38D6C", family: "brown" },
  { number: "3864", name: "Mocha Beige Light", hex: "#CBB99A", family: "neutral" },
  { number: "3865", name: "Winter White", hex: "#FFFDF0", family: "white" },
  { number: "3866", name: "Mocha Brown Ultra Very Light", hex: "#F5EDE0", family: "neutral" },
  { number: "3880", name: "Medium Very Dark Shell Pink", hex: "#A04050", family: "pink" },
  { number: "3881", name: "Pale Autumn Gold", hex: "#F5D898", family: "yellow" },
  { number: "3882", name: "Medium Light Cocoa", hex: "#B0886A", family: "brown" },
  { number: "3883", name: "Medium Light Copper", hex: "#DC9C6A", family: "orange" },
  { number: "3884", name: "Bright Lemon", hex: "#FFF44F", family: "yellow" },
  { number: "3885", name: "Medium Very Dark Emerald Green", hex: "#0B6623", family: "green" },
  { number: "3886", name: "Very Dark Plum", hex: "#6B1B3A", family: "pink" },
  { number: "3887", name: "Ultra Very Dark Lavender", hex: "#5A2D72", family: "purple" },
  { number: "3888", name: "Medium Dark Antique Blue", hex: "#4F7080", family: "blue" },
  { number: "3889", name: "Medium Light Cranberry", hex: "#E87098", family: "pink" },
  { number: "3890", name: "Very Light Bright Turquoise", hex: "#92E8E8", family: "blue" },
  { number: "3893", name: "Very Light Mocha Beige", hex: "#DCC8A8", family: "neutral" },
  { number: "3894", name: "Very Light Parrot Green", hex: "#C8D86C", family: "green" },
  { number: "3895", name: "Medium Dark Beaver Grey", hex: "#787468", family: "grey" },
  { number: "3896", name: "Medium Light Tawny", hex: "#F0D0A0", family: "neutral" },
  { number: "3897", name: "Very Dark Rosewood", hex: "#5A2828", family: "brown" },
  { number: "3898", name: "Very Dark Grey Green", hex: "#344838", family: "green" },
  { number: "226", name: "Rose Ultra Dark", hex: "#98273B", family: "red" },
  { number: "227", name: "Very Dark Rose", hex: "#A8303E", family: "red" },
  { number: "3891", name: "Very Dark Cornflower Blue", hex: "#3A4E8F", family: "blue" },
  { number: "3892", name: "Medium Light Orange Spice", hex: "#F59562", family: "orange" },
  { number: "3899", name: "Medium Dark Rose", hex: "#C44060", family: "pink" },
  { number: "01", name: "White Tin", hex: "#F8F8F0", family: "white" },
  { number: "02", name: "Tin", hex: "#E8E5DC", family: "neutral" },
  { number: "03", name: "Medium Tin", hex: "#D5D0C5", family: "neutral" },
  { number: "04", name: "Dark Tin", hex: "#B0AAA0", family: "grey" },
  { number: "05", name: "Very Dark Driftwood", hex: "#6F644E", family: "brown" },
  { number: "06", name: "Medium Light Driftwood", hex: "#A89870", family: "brown" },
  { number: "07", name: "Light Driftwood", hex: "#C0B48C", family: "neutral" },
  { number: "08", name: "Very Light Driftwood", hex: "#D8CCA8", family: "neutral" },
  { number: "09", name: "Very Dark Cocoa", hex: "#5C3824", family: "brown" },
  { number: "10", name: "Very Light Tender Green", hex: "#CEDE9C", family: "green" },
  { number: "11", name: "Light Tender Green", hex: "#B8D080", family: "green" },
  { number: "12", name: "Tender Green", hex: "#A0C468", family: "green" }
];
